import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CondominiumWritePage } from './condominium-write';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		CondominiumWritePage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(CondominiumWritePage),
	],
})
export class CondominiumWritePageModule {}



// WEBPACK FOOTER //
// ./src/pages/condominium-write/condominium-write.module.ts